import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/auth";
import { RoleEnum } from "../../types";
import WorkPlanForEmployee from "./WorkPlanForEmployee";
import WorkPlanForManagementStaff from "./WorkPlanForManagementStaff";
import WorkPlanForManager from "./WorkPlanForManager";
import WorkPlanForManagerManager from "./WorkPlanManagerManager";

export default function WorkPlan() {
  const { t } = useTranslation();
  const { user } = useAuth();

  if (!user) {
    return <div className="p-6">{t("noPermissions")}</div>;
  }

  const { roles = [], isTimeManager } = user;

  if (roles.includes(RoleEnum.Pracownik) && !isTimeManager) {
    return <WorkPlanForEmployee />;
  }

  if (
    roles.includes(RoleEnum.Kierownik) ||
    roles.includes(RoleEnum.Majster) ||
    (roles.includes(RoleEnum.Pracownik) && isTimeManager) ||
    (roles.includes(RoleEnum.Majster) && isTimeManager)
  ) {
    return <WorkPlanForManager />;
  }

  if (roles.includes(RoleEnum.Manager)) {
    return <WorkPlanForManagerManager />;
  }

  if (
    roles.includes(RoleEnum.KadrySpolki) ||
    roles.includes(RoleEnum.AdministratorSpolki) ||
    roles.includes(RoleEnum.AdministratorGlowny)
  ) {
    return <WorkPlanForManagementStaff />;
  }

  return <div className="p-6">{t("noPermissions")}</div>;
}
